import { render, staticRenderFns } from "./ViewLogistics.vue?vue&type=template&id=175fb036&scoped=true"
import script from "./ViewLogistics.vue?vue&type=script&lang=js"
export * from "./ViewLogistics.vue?vue&type=script&lang=js"
import style0 from "./ViewLogistics.vue?vue&type=style&index=0&id=175fb036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175fb036",
  null
  
)

export default component.exports